var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 258,
    viewBox: "0 0 211 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1104)",
    filter: "url(#filter0_dd_0_1104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 23,
    width: 173.117,
    height: 221,
    fill: "url(#paint0_linear_0_1104)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.117 23H25V244H198.117V23ZM48.7885 32.2083C39.6344 32.2083 32.2135 39.6292 32.2135 48.7833V218.217C32.2135 227.371 39.6344 234.792 48.7885 234.792H174.329C183.483 234.792 190.904 227.371 190.904 218.217V48.7833C190.904 39.6292 183.483 32.2083 174.329 32.2083H48.7885Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.786 109.825C145.654 116.569 146.028 128.559 139.035 135.803L114.81 160.782C113.311 162.406 110.689 162.406 109.19 160.782L84.9648 135.803C77.9718 128.559 78.3464 116.569 86.2135 109.825C93.0816 103.955 103.321 105.079 109.565 111.573L112.062 114.071L114.435 111.573C120.804 105.079 130.918 103.955 137.786 109.825Z",
    fill: "url(#paint1_linear_0_1104)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_1104",
    x: 0.200001,
    y: 0.200001,
    width: 210.317,
    height: 257.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.922969 0 0 0 0 0.920293 0 0 0 0 0.920293 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1104",
    result: "effect2_dropShadow_0_1104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1104",
    x: 22.5444,
    y: 20.5444,
    width: 179.256,
    height: 227.139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.613889,
    dy: 0.613889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53472
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1104",
    x: 62.8,
    y: 88.8,
    width: 98.4,
    height: 98.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.982523 0 0 0 0 0.515133 0 0 0 0 0.65599 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1104",
    x1: 111.558,
    y1: 23,
    x2: 111.558,
    y2: 244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBA8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FBA8C1",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA8C1",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1104",
    x1: 112,
    y1: 106,
    x2: 112,
    y2: 405.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E8E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173.117,
    height: 221,
    fill: "white",
    transform: "translate(25 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCard);
export default __webpack_public_path__ + "static/media/redCard.3d69d6b83687da72881480a6f4a46e43.svg";
export { ForwardRef as ReactComponent };